




























































































































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import {
  Image,
  ProductVariant,
  ProductVariantOption,
} from '@/models';
import { WithAppContext } from '@/mixins';

import api from '@/api';

import bContainer from 'bootstrap-vue/es/components/layout/container';

import AvailabilityFeature from '@/components/product/AvailabilityFeature.vue';
import BuyboxFeature from '@/components/product/BuyboxFeature.vue';
import DesktopPriceFeature from '@/components/product/DesktopPriceFeature.vue';
import FeatureBulletsFeature from '@/components/product/FeatureBulletsFeature.vue';
import ImageBlockFeature from '@/components/product/ImageBlockFeature.vue';
import PaletteFeature from '@/components/product/PaletteFeature.vue';
import PriceFeature from '@/components/product/PriceFeature.vue';
import ShareButtonsFeature from '@/components/product/ShareButtonsFeature.vue';
import TitleFeature from '@/components/product/TitleFeature.vue';

import { ProductFeatureContext } from '@/components/product/ProductFeatureContext';

@Component({
  components: {
    bContainer,

    AvailabilityFeature,
    BuyboxFeature,
    DesktopPriceFeature,
    FeatureBulletsFeature,
    ImageBlockFeature,
    PaletteFeature,
    PriceFeature,
    ShareButtonsFeature,
    TitleFeature,
  },
})
export default class Product extends mixins(WithAppContext) {
  // Variant to be shown indicated by `$route.params.productVariantId`.
  public variant: ProductVariant | null = null;

  // The variant to be previewed
  public previewVariant: ProductVariant | null = null;

  // The set of values corresponding to each Product option provided by the user to select variant.
  public selectedValues: Array<ProductVariantOption | undefined> = [];

  public created() {
    // Load product data.
    this.loadVariant();
  }

  get context(): ProductFeatureContext {
    // "Product" component itself implements a ProductFeatureContext.
   return this as ProductFeatureContext;
  }

  @Watch('variant')
  private onVariantChange() {
    // Update `selectedValues`.
    this.selectedValues = this.selectedValues.map((value, idx) => (
      (value) ? (this.variant!.options!)[idx] : value
    ));
  }

  private async loadVariant() {
    api.fetchVariant(this.$route.params.productVariantId)
      .then((variant) => {
        this.variant = variant;
        if (variant.options) {
          // Initialize `selectedValues`.
          this.selectedValues = variant.options.map((value) => (
            (value.option.shouldPromptSelection) ? undefined : value
          ));
        }
      });
  }
}

